import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-custom-slider',
  templateUrl: './custom-slider.component.html',
  styleUrls: ['./custom-slider.component.css']
})
export class CustomSliderComponent implements OnInit, OnChanges {
  @Output() valueChange = new EventEmitter<number>();
  @Input() disablePrompt: boolean;
  @Input() value: number;
  labelPosition = 'calc(0% + 4%)';
  showIndicator: boolean;

  ngOnInit() {
    this.showIndicator = false;
    this.calculateLabelPosition();
  }

  onInputChange(event: any) {
    this.showIndicator = true;
    this.value = event.value > 1 ? 1 : !!Number(event.value) ? event.value : 0;
    this.valueChange.emit(this.value);
    this.calculateLabelPosition();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.calculateLabelPosition();
    if (this.value == 0) {
      this.showIndicator = false;
    }
  }

  onSliderMove(event: MouseEvent) {
    this.showIndicator = true;
    const slider = event.target as HTMLInputElement;
    this.value = Number(slider.value);
    this.valueChange.emit(this.value);
    this.calculateLabelPosition();
  }

  interpolateValue(input) {
    if (input <= 0) {
      return +4;
    } else if (input >= 100) {
      return -4;
    } else {
      return ((input - 50) / -50) * 4;
    }
  }

  calculateLabelPosition() {
    if (!!this.value) {
      const range = document.querySelector('input[type="range"]');
      let max = parseInt(range.getAttribute('max'));
      let diff = this.interpolateValue((100 * ((this.value ? this.value : 0) / max)));
      let CalculateValue = (100 * ((this.value ? this.value : 0) / max)) + (diff);
      this.labelPosition = `${CalculateValue}%`;
    }
    else {
      this.labelPosition = 'calc(0% + 4%)';
    }
  }

  handleKeydown(e) {
    const typedValue = e.keyCode;
    if ((typedValue < 48 && typedValue > 57) || typedValue == 69 || typedValue == 189) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    const typedNumber = e.key;
    const min = Number(e.target.min);
    const max = Number(e.target.max);
    const currentVal = e.target.value;
    let newVal = currentVal.toString() + typedNumber.toString();
    if (Number(newVal) > max || Number(newVal) < min) {
      newVal = this.value;
      e.target.value = this.value;
      e.preventDefault();
      e.stopPropagation();
    }
  }
}
